import { ErrorInfo, Realtime } from 'ably';
import { AblyProvider, ChannelProvider } from 'ably/react';
import { ReactNode, useMemo } from 'react';
import { useAuthenticationContext } from 'contexts';
import { useSubscriberId } from './SubscriberIdProvider';

export const AblyPushingProvider = ({ children }: { children?: ReactNode }) => {
  const { getIdToken } = useAuthenticationContext();
  const subscriberId = useSubscriberId();

  const ablyClient = useMemo(
    () =>
      new Realtime({
        authCallback: async (_tokenParams, callback) => {
          try {
            const idToken = await getIdToken();

            const url = new URL(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/user/ably-auth`);
            url.searchParams.append('clientId', subscriberId);

            const res = await fetch(url.toString(), {
              headers: { Authorization: `Bearer ${idToken}` },
            });
            const tokenRequest = await res.json();

            callback(null, tokenRequest);
          } catch (err) {
            callback(err as ErrorInfo, null);
          }
        },
      }),
    [getIdToken, subscriberId],
  );

  if (!ablyClient) {
    return null;
  }

  return (
    <AblyProvider client={ablyClient}>
      <ChannelProvider channelName={`user-${subscriberId}`}>{children}</ChannelProvider>
    </AblyProvider>
  );
};
